// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/thigh-springs-for-opening-a-flap-in-dishwashers/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteThighSpringsForOpeningAFlapInDishwashersEN: PageEntry = {
  id: "example.produkte-schenkelfedern-zum-oeffnen-einer-klappe-bei-geschirrspuelmaschinen",
  locale: "en",
  slug: "produkte/thigh-springs-for-opening-a-flap-in-dishwashers",
  seo: {
    title: "Thigh springs for opening a flap in dishwashers | Dietz GmbH",
    description: "Special tools for special bending processes",
  },
  type: "post",
  h1: "Thigh springs for opening a flap in dishwashers",
  intro: "Special tools for special bending processes",
  blocks: [
    { kind: "image", src: "/images/live/dtz-schenkelfeder-geschirrsp.jpg", alt: "Thigh springs for opening a flap in dishwashers", width: 1400, height: 1120 }
  ],
};
